export default function PanneElectrique() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Panne de volet roulant électrique
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Un volet roulant électrique qui refuse de fonctionner peut perturber le quotidien de toute une habitation. Que ce soit un moteur silencieux qui ne démarre plus, un tablier bloqué en position intermédiaire ou une télécommande qui n'active plus le mécanisme, chaque panne électrique possède ses propres causes et solutions. Contrairement à un volet manuel, le dysfonctionnement d'un volet électrique implique une chaîne de commande plus complexe : alimentation électrique, moteur tubulaire, récepteur radio, interrupteur mural, télécommande, et parfois même une box domotique.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Notre service de réparation intervient sur tous les types de pannes électriques dans le Bas-Rhin. Nous ne remplaçons pas le moteur à l'aveugle : notre technicien procède à un diagnostic complet pour identifier précisément l'origine du problème. Il peut s'agir d'un simple défaut de programmation, d'une coupure de courant localisée, d'une fin de course mal réglée ou d'une usure progressive du condensateur. En ciblant l'élément exact en panne, nous évitons des remplacements coûteux et inutiles. Notre intervention couvre aussi bien les volets roulants de particuliers que les installations collectives de copropriétés, avec des pièces détachées adaptées à chaque marque de motorisation.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Symptômes d'un volet électrique en panne
        </h3>
        <ul className="space-y-3 mb-8">
          {[
            "Le volet ne répond plus à la télécommande ni à l'interrupteur mural",
            "Le moteur tourne mais le tablier ne bouge, signe d'un débrayage ou d'un axe cassé",
            "Mouvements saccadés ou arrêts intempestifs en cours de montée ou descente",
            "Bruit de bourdonnement ou d'arc électrique sans rotation du moteur",
            "Télécommande dont le voyant clignote sans actionner le volet",
            "Volet bloqué en position ouverte ou fermée, impossible à manœuvrer manuellement",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Causes principales des pannes électriques
        </h3>
        <ul className="space-y-3">
          {[
            "Moteur tubulaire usé ou grippé après 10 à 15 ans de fonctionnement",
            "Condensateur de démarrage défectueux ou platine de commande endommagée",
            "Déprogrammation ou perte de liaison entre la télécommande et le récepteur",
            "Coupure d'alimentation électrique, disjoncteur différentiel déclenché",
            "Fin de course mal réglée ou capteur de position hors service",
            "Obstacle mécanique dans le tablier ou glissière déformée forçant le moteur",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}